<template>
  <span class="multiselect-native-select">
    <div class="select-box checkbox">
      <multi-select
        :value="selectedInfo"
        :label="text"
        :track-by="track"
        :options="selectOption"
        :multiple="true"
        :show-labels="false"
        :placeholder="placeholderText"
        :preserve-search="true"
        :close-on-select="false"
        :clear-on-select="false"
        @remove="itemRemove"
        @select="itemSelect"
        @close="selectBoxClose"
        @open="selectBoxOpen"
      >
        <span
          slot="noResult">{{ $t("multiSelectBox.noData") }}</span><!--검색 결과가 없습니다.-->
        <template
          slot="selection"
          slot-scope="{ values, search, isOpen }">
          <span
            v-if="values.length &amp;&amp; !isOpen"
            class="multiselect__single">{{ placeholderText }} ({{ filterSelectedCount }} / {{ filterTotalCount }})</span>
        </template>
      </multi-select>
    </div>
  </span>
</template>

<script>

import _isEmpty from "lodash/isEmpty";

export default {
  name: "MultiSelectBox",
  components: {
  },
  props: {
    selectOption: {
      type: Array[String],
      default: null
    },
    placeholder: {
      type: String,
      default: 'multiSelectBox.placeholder'
    },
    placeholderSelect: {
      type: String,
      default: 'multiSelectBox.placeholderSelect'

    },
    placeholderSelectAll: {
      type: String,
      default: "multiSelectBox.allSelectOption"
    },
    text: {
      type: String,
      default: null
    },
    track: {
      type: String,
      default: null
    },
    preSelectedItems: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      selectedInfo: [],
      filterTotalCount: "",
      filterSelectedCount: "",
      selectAllText: this.$t(this.placeholderSelectAll),// this.$t('multiSelectBox.allSelectOption'),
      placeholderText: this.$t(this.placeholder)
    };
  },
  watch: {
    '$i18n.locale': {
      handler() {
        setTimeout(() => {
          this.selectAllText = this.$t(this.placeholderSelectAll);
          this.placeholderText = this.$t(this.placeholder);
        }, 200)
      },
    },
    preSelectedItems: {
      handler() {
        if(!_isEmpty(this.selectedInfo)){
          this.filterSelectedCount = this.selectedInfo.length;
          this.filterTotalCount = this.selectOption.length;
        }
      }
    }
  },
  beforeMount() {
    this.placeholderText = this.$t(this.placeholder);
    this.selectAllText = this.$t(this.placeholderSelectAll);
  },
  methods: {

    itemSelect(event) {
      let hasOptionAll = this.$props.selectOption.filter(opt => opt.text === this.selectAllText).length > 0;
      if(hasOptionAll) {
        this.filterTotalCount = this.selectOption.length - 1;
      } else {
        this.filterTotalCount = this.selectOption.length;
      }

      if (event === this.selectAllText || event.text === this.selectAllText) {/*전체 선택*/
        this.selectedInfo = [];
        for (let item of this.selectOption) {
          this.selectedInfo.push(item);
          this.$emit('handle-select', item);
        }
        this.filterSelectedCount = this.filterTotalCount;
      } else {
        this.selectedInfo.push(event);
        this.filterSelectedCount = this.selectedInfo.length;

        // 선택된 개수와 전체옵션 개수가 같으면 전체 선택 체크 처리
        if(hasOptionAll && this.filterTotalCount==this.filterSelectedCount) {
          this.selectedInfo.push(this.selectOption[0]);
        }

        this.$emit('handle-select', event);
      }
    },

    itemRemove(event) {

      if (event === this.selectAllText || event.text === this.selectAllText) {/*전체 선택*/
        for (let item of this.selectOption) {
          this.selectedInfo.pop();
          this.$emit('handle-select', item);
        }
        this.filterSelectedCount = 0;
      } else {
        this.filterSelectedCount = this.filterSelectedCount - 1;
        // const idx = this.selectedInfo.indexOf(event);
        const idx = this.selectedInfo.findIndex(d => d.item === event.item && d.text === event.text )
        if (idx > -1) this.selectedInfo.splice(idx, 1);
        this.$emit('handle-select', event);

        if(this.selectedInfo.length > 0 ){
          this.selectedInfo = this.selectedInfo.filter( option => {
            if(option.item === this.selectAllText) {
              this.$emit('handle-select', option);
              return false;
            }
            return true;
          })


          if(this.selectedInfo[0] == this.selectAllText || this.selectedInfo[0].text == this.selectAllText){ // 전체 선택 //
            this.$emit('handle-select', this.selectedInfo[0]);
            this.selectedInfo.splice(0, 1);
          }

        }
      }
    },
    selectBoxOpen() {
      if(this.placeholderSelect && this.placeholderSelect!="") {
        this.placeholderText = this.$t(this.placeholderSelect);
      }
    },
    selectBoxClose() {
      this.placeholderText = this.$t(this.placeholder);
      this.$emit('selectedInfo', this.selectedInfo);
    }
  }
};

</script>



<style lang="scss">
.multiselect-native-select{
  width: 220px;
  .multiselect__tags{
    padding: 5px 9px 5px 12px;
    border-radius: 4px;
    border: solid 1px var(--lightgray-1);
    min-height: 1.5rem;
    font-size: 0.75rem;
    font-weight: 400;
    color: #222222;
    margin-top: 0.25rem;
    & > input[type=text]{
      font-size: 0.75rem;
      font-weight: 400;
      color: #B3B3B3;
      height: 1.375rem;
      line-height: 1.375rem;
    }
    .multiselect__input,.multiselect__single{
      height: 32px;
      font-size: 0.75rem;
      font-weight: 400;
      color: #B3B3B3;
      line-height: 1.375rem;
    }
    .multiselect__placeholder{
      font-size: 0.75rem;
      font-weight: 400;
      color: #B3B3B3;
      line-height: 1.375rem;
    }
    .multiselect__single{
      padding-left: 0;
      padding-top: 0;
    }
  }

  .multiselect{
    &.multiselect--active{
      .multiselect__tags{
        & > input[type=text]{
          font-size: 0.75rem;
          font-weight: 400;
          color: #B3B3B3;
          height: 1.375rem;
          line-height: 1.375rem;
          padding: 0;
          margin: 0;
          width: calc(100% - 40px)!important;
          display: block;
        }
      }
    }
  }

  .multiselect__content-wrapper{
    margin-top: 2px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .5);
    padding: 4px 0;
    border-radius: 4px;
    box-shadow: 0 3px 12px 2px rgba(124, 129, 148, 0.25);
    background-color: var(--white);
    .multiselect__content{
      .multiselect__element{
        //margin-top: 10px;
        font-size: 0.75rem;
        //height: 32px;
      }
    }
  }

  .multiselect__select{
    height: 32px;
  }

  .multiselect__select{
    background-image: url("/static/images/tansparency_select_box_arrow_down@2x.png");
    background-size: 10px 7px;
    background-repeat: no-repeat;
    background-position: center;
    &:before{
      border-width: 0;
    }
  }

  .multiselect{
    &.multiselect--active{
      z-index: 700;
    }
  }

  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 0.75rem;
    width: calc(100% - 40px)!important;
  }

  .multiselect__spinner{
    width: 28px;
    height: 28px;
  }
  .multiselect__placeholder{
    line-height: 30px;
    margin-bottom: 0;
    padding-top: 0;
    font-size: 0.875rem;
    font-weight: 400;
    color: #666;
  }

  .multiselect--disabled .multiselect__current,
  .multiselect--disabled .multiselect__select,
  .multiselect__option--disabled{
    background-color: #F2F2F2;
  }

  .multiselect--disabled{
    opacity: 1;
    background-color: #F2F2F2;
    pointer-events: auto;
    cursor: not-allowed;
    &:hover{
      cursor: not-allowed;
    }
    .multiselect__single{
      background-color: #F2F2F2;
    }
    .multiselect__select{
      background-image: url("/static/images/tansparency_select_box_arrow_down@2x.png");
      background-size: 10px 7px;
      background-repeat: no-repeat;
      background-position: center;
      opacity: .4;
      height: 32px;
      //pointer-events: auto;
      //cursor: not-allowed;
    }
    .multiselect__tags{ background-color: #F2F2F2; color: #666;}
  }

  .multiselect__option--highlight {
    background-color: rgba(0, 0, 0, 0.08) !important;
    color: #222222 !important;
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background-color: rgba(0, 0, 0, 0.08) !important;
    color: #222222 !important;
  }



  .multiselect__tags{
    background-color: #ffffff;
    border-radius: 4px;
    height: 32px;
    overflow: hidden;
    input{
      &[type=text]{
        border: 0;
        font-size: 0.875rem;
        //width: 0px;
        display: none;
      }
    }
  }

  .multiselect__tags-wrap {
    display: none!important;
  }

  .checkbox{
    .multiselect__element{
      .multiselect__option{
        padding-left: 32px;
        display: flex;
        align-items: center;
        width: 100%;
        &.multiselect__option--selected{
          span{
            &:before{
              opacity: 1;
              background-color: rgba(0, 0, 0, 0.08)!important;
              color: #222222!important;
            }
          }
        }
        &.multiselect__option--selected{
          span{
            &:after{
              opacity: 0;
              background-color: rgba(0, 0, 0, 0.08)!important;
              color: #222222!important;
            }
          }
        }
        span{
          &:before{
            position: absolute;
            top: 50%;
            left: 12px;
            display: block;
            width: 12px;
            height: 12px;
            margin-top: -6.5px;
            content: '';
            transition: opacity .3s ease-in-out;
            opacity: 0;
            background-image: url("/static/images/checkbox_checked.png");
            background-size: 12px 12px;
            background-repeat: no-repeat;
            background-position: center;
          }
          &:after{
            position: absolute;
            top: 50%;
            left: 12px;
            display: block;
            width: 12px;
            height: 12px;
            margin-top: -6.5px;
            content: '';
            background-image: url("/static/images/checkbox_normal.png");
            background-size: 12px 12px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/multi-select-box/MultiSelectBox.vue